import { render, staticRenderFns } from "./DossierInformations.vue?vue&type=template&id=72285228"
import script from "./DossierInformations.vue?vue&type=script&lang=js"
export * from "./DossierInformations.vue?vue&type=script&lang=js"
import style0 from "./DossierInformations.vue?vue&type=style&index=0&id=72285228&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports